import { useSyncExternalStore } from 'react';

function subscribeTo(query: string) {
  return (onChange: () => void) => {
    if (typeof window.matchMedia !== 'function') return () => undefined;
    const list = window.matchMedia(query);
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  };
}

function matches(query: string): boolean {
  return typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
}

export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
export const MOBILE_QUERY = '(max-width: 767px)';

const subscribeReduced = subscribeTo(REDUCED_MOTION_QUERY);
const subscribeMobile = subscribeTo(MOBILE_QUERY);

export function useReducedMotion(): boolean {
  return useSyncExternalStore(
    subscribeReduced,
    () => matches(REDUCED_MOTION_QUERY),
    () => false,
  );
}

/** Below the `md` breakpoint: the step card becomes a bottom sheet. */
export function useIsMobile(): boolean {
  return useSyncExternalStore(
    subscribeMobile,
    () => matches(MOBILE_QUERY),
    () => false,
  );
}

export const isMobileViewport = () => matches(MOBILE_QUERY);
